var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialAppleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1128_154762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1599 15.5863C17.8575 16.2851 17.4995 16.9283 17.0847 17.5196C16.5192 18.3257 16.0563 18.8838 15.6995 19.1936C15.1464 19.7022 14.5539 19.9627 13.9193 19.9775C13.4638 19.9775 12.9144 19.8479 12.2749 19.585C11.6333 19.3232 11.0437 19.1936 10.5046 19.1936C9.9392 19.1936 9.3328 19.3232 8.68418 19.585C8.03457 19.8479 7.51125 19.985 7.11114 19.9985C6.50264 20.0245 5.89612 19.7566 5.29071 19.1936C4.9043 18.8566 4.42098 18.2788 3.84199 17.4603C3.22077 16.5863 2.71005 15.5727 2.30994 14.4172C1.88143 13.1691 1.66663 11.9605 1.66663 10.7904C1.66663 9.45008 1.95625 8.29407 2.53635 7.32533C2.99226 6.54721 3.59879 5.9334 4.3579 5.4828C5.11701 5.03219 5.93723 4.80257 6.82054 4.78788C7.30385 4.78788 7.93766 4.93738 8.72529 5.2312C9.5107 5.52601 10.015 5.67551 10.2361 5.67551C10.4014 5.67551 10.9616 5.5007 11.9114 5.15219C12.8095 4.82899 13.5675 4.69517 14.1884 4.74788C15.8711 4.88368 17.1353 5.54699 17.976 6.74202C16.4711 7.65384 15.7267 8.93096 15.7415 10.5693C15.7551 11.8454 16.218 12.9074 17.1279 13.7506C17.5402 14.1419 18.0007 14.4444 18.513 14.6592C18.4019 14.9814 18.2846 15.29 18.1599 15.5863ZM14.3008 0.400358C14.3008 1.40059 13.9354 2.3345 13.207 3.19892C12.328 4.22654 11.2648 4.82035 10.1119 4.72665C10.0972 4.60665 10.0887 4.48036 10.0887 4.34765C10.0887 3.38743 10.5067 2.3598 11.249 1.51958C11.6196 1.09416 12.091 0.740434 12.6626 0.458257C13.2329 0.18029 13.7724 0.0265683 14.2798 0.000244141C14.2946 0.133959 14.3008 0.267682 14.3008 0.400345V0.400358Z",
    fill: "url(#paint0_linear_1128_154762)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1128_154762",
    x1: 1.66663,
    y1: 10.0002,
    x2: 18.513,
    y2: 10.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1128_154762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialAppleIcon);
export default __webpack_public_path__ + "static/media/SocialAppleIcon.0a8bbc6a554ddc7d1fcf6badcacd7098.svg";
export { ForwardRef as ReactComponent };